import { rtdb } from "/firebaseConfig";
import { ref, runTransaction } from "firebase/database";
import { useUserStore } from "@/store/user";

/**
 * 통계 추적 함수
 * @param {string} eventType - 이벤트 타입 (예: 'liveDetailView', 'ticketClick', etc.)
 * @param {string} id - 대상 ID (예: live ID, artist ID)
 */
export const trackStatistics = (eventType, id = null) => {
  // localhost에서는 통계 카운팅 제외
  if (window.location.hostname.includes("localhost")) {
    return;
  }

  const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD 형식
  const userStore = useUserStore();
  const isAdmin = userStore.auth === "admin";

  // 전체 이벤트 카운트
  const totalEventRef = ref(rtdb, `statistics/${eventType}/${today}/total`);
  runTransaction(totalEventRef, (currentValue) => {
    return (currentValue || 0) + 1;
  });

  // 특정 ID에 대한 카운트 (ID가 제공된 경우)
  if (id) {
    const specificEventRef = ref(
      rtdb,
      `statistics/${eventType}/${today}/${id}`
    );
    runTransaction(specificEventRef, (currentValue) => {
      return (currentValue || 0) + 1;
    });
  }

  // 관리자인 경우 별도로 카운트
  if (isAdmin) {
    const adminEventRef = ref(
      rtdb,
      `statisticsAdmin/${eventType}/${today}/total`
    );
    runTransaction(adminEventRef, (currentValue) => {
      return (currentValue || 0) + 1;
    });

    // 특정 ID에 대한 관리자 카운트
    if (id) {
      const adminSpecificEventRef = ref(
        rtdb,
        `statisticsAdmin/${eventType}/${today}/${id}`
      );
      runTransaction(adminSpecificEventRef, (currentValue) => {
        return (currentValue || 0) + 1;
      });
    }
  }
};

/**
 * LiveDetail 화면 접속 통계
 * @param {string} liveId - 공연 ID
 */
export const trackLiveDetailView = (liveId) => {
  trackStatistics("liveDetailView", liveId);
};

/**
 * 예매하기 링크 클릭 통계
 * @param {string} liveId - 공연 ID
 */
export const trackTicketClick = (liveId) => {
  trackStatistics("ticketClick", liveId);
};

/**
 * LiveDetail 링크이동 클릭 통계
 * @param {string} liveId - 공연 ID
 */
export const trackLiveLinkClick = (liveId) => {
  trackStatistics("liveLinkClick", liveId);
};

/**
 * ArtistDetail 화면 접속 통계
 * @param {string} artistId - 아티스트 ID
 */
export const trackArtistDetailView = (artistId) => {
  trackStatistics("artistDetailView", artistId);
};

/**
 * Artist 링크이동 클릭 통계
 * @param {string} artistId - 아티스트 ID
 */
export const trackArtistLinkClick = (artistId) => {
  trackStatistics("artistLinkClick", artistId);
};

/**
 * 커뮤니티 화면 접속 통계
 */
export const trackCommunityView = () => {
  trackStatistics("communityView");
};

/**
 * 메뉴 클릭 통계
 * @param {string} menuName - 메뉴 이름 (artist, community, venue, notifications, profile)
 */
export const trackMenuClick = (menuName) => {
  trackStatistics(`menu_${menuName}`);
};
